import styled from "styled-components";
import Colors from "../../Constant/Colors";
import { STYLES } from "../../Constant/Theme";

export const Container = styled.div`
  /* display: ${(props) => (props.isChatOpen ? "flex" : "none")}; */
  width: ${(props) => (props.isInstructor ? "497px" : "497px")};
  /* width: 295px; */
  /* height: calc(100vh -100px); */
  height: 80%;
  position: absolute;
  left: 5px;
  top: 125px;
  flex-direction: column;
  box-sizing: border-box;
  transition: width 0.9s ease-in-out;
  background-color: ${Colors.whiteThemeColor};
  /* padding-top: 60px; */
  padding-left: 10px;
  padding-right: 10px;

  @media only screen and (max-width: 600px) {
    width: ${(props) => (props.toggleSideBar ? "180px" : "0px")};
    background-color: ${Colors.whiteThemeColor};
    z-index: 500;
    box-shadow: 1px 1px 5px 1px ${Colors.lightTxt};
  }
`;

export const EachStudent = styled.div`
  ${STYLES.HorizontalLeftAlign};
  padding-left: 20px;
  margin-top: 10px;
`;
export const CircleIcon = styled.div`
  ${STYLES.HorizontalAlign};
  border-radius: 50%;
  background-color: ${Colors.primary};
`;

export const Dot = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${props => props.isActive ? Colors.primary : Colors.red};
  border-radius: 50px;
`;
export const ChatList = styled.div`
  display: flex;
  flex-direction: column;
`;
export const EachChat = styled.div`
  margin-top: 5px;
  margin-bottom: 10px;
  border-bottom: 0.5px solid #6662;
  padding-bottom: 5px;
  height: ${(props) => (props.toggle ? null : "25px")};
  overflow-y: hidden;
  cursor: pointer;
  transition: height 0.9s ease-in-out; /* Transition with ease-in-out timing function */
`;
export const CustomTextDiv = styled.div`
  @media only screen and (max-width: 600px) {
    display: none;
  }
`;
